export const BUFFER = 50;
export const FIRST = 100;

export const TRACE_LINKS_FIRST = 20;

// When a deep-linked (older) link opens the inspector, the initial window is
// anchored on that link with roughly this many links loaded on each side, so
// the target lands centered and the user can page in either direction.
export const TRACE_LINKS_ANCHOR_HALF_WINDOW = 10;
